<template>
  <div>
    <el-dialog
      width="632px"
      :visible="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :modal="false"
    >
      <div slot="title">
        <div class="el-dialog__title">
          {{ $t('CampaignForm_ApplyTemplateDialog_Title') }}
        </div>
      </div>
      <div class="items-container">
        <radio-group v-model="selectedTemplate">
          <rest-list
            :top-data="topData"
            :payload="templatesFetchEndpoint"
            :after-fetch="resetSelection"
            ref="list"
            :max-height="500"
          >
            <template>
              <rest-list-column
                :title="$t('Campaign_Apply_Template_Dialog_Title_Column')"
                prop="title"
              >
                <template slot-scope="scope">
                  <radio :label="scope.row" :title="scope.row.title" />
                </template>
              </rest-list-column>
            </template>
          </rest-list>
        </radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          @click="applyTemplate"
          :disabled="selectedTemplate === null"
        >
          <span>{{ $t('Campaign_Dialog_Button_Apply') }}</span>
          <i class="el-icon-arrow-right el-icon--right" />
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import { customConfirm, projectEndpoint } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import Radio from '@/common/components/form/Radio'
import RadioGroup from '@/common/components/form/RadioGroup'
import { EventBus } from '@/core/EventBus'
export default {
  name: 'ApplyTemplateDialog',
  components: {
    RadioGroup,
    Radio,
    RestListColumn,
    RestList
  },
  props: {
    messageType: {
      type: Number,
      required: true
    },
    showConfirmation: {
      type: Boolean,
      default: false
    },
    currentMessage: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedTemplate: null,
      topData: []
    }
  },

  computed: {
    templatesFetchEndpoint() {
      const lang = this.$route.query.lang || 'default'

      return projectEndpoint({
        method: 'get',
        url: 'campaign-templates',
        params: {
          is_active: 1,
          message_type: this.messageType,
          expand: 'message',
          for: 'vue',
          lang: lang
        }
      })
    }
  },

  methods: {
    resetSelection() {
      if (
        this.currentMessage &&
        this.currentMessage.template_context &&
        !this.currentMessage.template_context.is_deleted
      ) {
        this.$refs.list.data = this.$refs.list.data.filter(item => {
          if (item.id === this.currentMessage.template_context.id) {
            this.selectedTemplate = item
            this.topData = [item]

            return false
          }
          return true
        })
      }
    },
    handleClose() {
      EventBus.$emit('applyMessageTemplateDialog', null)
    },
    applyTemplate() {
      if (this.showConfirmation) {
        customConfirm(
          this.$t('CampaignForm_ApplyTemplateDialog_Confirm_Title'),
          this.$t('CampaignForm_ApplyTemplateDialog_Confirm_Message'),
          this.$t('CampaignForm_ApplyTemplateDialog_Confirm_Btn_Confirm')
        ).then(() => {
          EventBus.$emit('applyMessageTemplate', this.selectedTemplate)
        })
      } else {
        EventBus.$emit('applyMessageTemplate', this.selectedTemplate)
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/ApplyTemplateDialog.vue